<template>
  <div class="edit-container">
    <div class="input-item">
      <span>收件人</span>
      <input placeholder="请输入收件人" v-model="addressData.name">
    </div>
    <div class="input-item">
      <span>联系电话</span>
      <input placeholder="请输入联系电话" v-model="addressData.mobile">
    </div>
    <div class="input-item">
      <span>省市区</span>
      <span @click="popupCity = true" style="color: #747474;font-size: 12px;">{{region}}</span>
      <van-popup v-model="popupCity" position="bottom">
        <van-area :area-list="areaList" @confirm="confirmArea" @cancel="popupCity = false"/>
      </van-popup>
    </div>
    <div class="input-item">
      <span>详细地址</span>
      <input placeholder="请输入详细地址" v-model="addressData.address">
    </div>
    <div class="input-item">
      <span>设为默认地址</span>
      <van-switch v-model="addressData.default" size="24px"/>
    </div>
    <div class="footer">
      <!-- <button v-if="id" class="footer-button delete" @click="toDelete">删除</button>
      <button v-else class="footer-button cancel" @click="toCancel">取消</button> -->
      <button v-if="id" class="footer-button" @click="editAddress">确认修改</button>
      <button v-else class="footer-button" @click="addAddress">确认添加</button>
    </div>
  </div>
</template>

<script>

import area from '@/util/area'
import Vue from 'vue'
import qs from 'qs'
import { Toast } from 'vant'
import { Area, Popup } from 'vant'
import { Switch } from 'vant'
import { Dialog } from 'vant'

Vue.use(Dialog)
Vue.use(Switch)
Vue.use(Toast)
Vue.use(Popup).use(Area)

export default {
  name: 'AddressEdit',
  data() {
    return {
      area: area,
      id: '',
      addressData: {},
      popupCity: false,
      region: '请选择所在地区 >',
      areaList: area
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id
      this.getData()
    }
  },
  methods: {
    getData() {
      var that = this
      this.axios.get('/user/address/' + this.$route.query.id + '/').then(function(res) {
        that.addressData = res.data
        that.region = res.data.province + ' ' + res.data.city + ' ' + res.data.district
      }).catch(function(error) {
        console.log(error)
      })
    },

    addAddress() {
      if (!this.addressData.name) {
        return Toast('请输入收件人')
      }
      if (!this.addressData.mobile) {
        return Toast('请输入联系电话')
      }
      if (!this.addressData.address) {
        return Toast('请输入详细地址')
      }
      var that = this
      var params = {
        name: this.addressData.name,
        mobile: this.addressData.mobile,
        province: this.addressData.province,
        city: this.addressData.city,
        district: this.addressData.district,
        address: this.addressData.address,
        default: this.addressData.default
      }
      this.axios.post('/user/address/', qs.stringify(params)).then(function(res) {
        console.log(res.data)
        if (res.data) {
          Toast('添加成功')
          setTimeout(() => {
            that.$router.go(-1)
          }, 500)
        } else {
          Toast(res.data.detail)
        }
      }).catch(function(error) {
        console.log(error)
        Toast('添加失败')
      })
    },

    editAddress() {
      if (!this.addressData.name) {
        return Toast('请输入收件人')
      }
      if (!this.addressData.mobile) {
        return Toast('请输入联系电话')
      }
      if (!this.addressData.address) {
        return Toast('请输入详细地址')
      }
      var that = this
      var params = {
        id: this.$route.query.id,
        name: this.addressData.name,
        mobile: this.addressData.mobile,
        province: this.addressData.province,
        city: this.addressData.city,
        district: this.addressData.district,
        address: this.addressData.address,
        default: this.addressData.default
      }
      this.axios.patch('/user/address/' + this.$route.query.id + '/', qs.stringify(params)).then(function(res) {
        console.log(res.data)
        if (res.data) {
          Toast('修改成功')
          setTimeout(() => {
            that.$router.go(-1)
          }, 500)
        } else {
          Toast(res.data.detail)
        }
      }).catch(function(error) {
        console.log(error)
        Toast('修改失败')
      })
    },

    confirmArea(data) {
      console.log(data)
      this.popupCity = false
      this.region = data[0].name + ' ' + data[1].name + ' ' + data[2].name
      this.addressData.province = data[0].name
      this.addressData.city = data[1].name
      this.addressData.district = data[2].name
    },

    toDelete() {
      Dialog.confirm({
        title: '确认删除吗'
      }).then(() => {
        var that = this
        this.axios.delete('/user/address/' + this.$route.query.id).then(function(res) {
          Toast('删除成功')
          setTimeout(() => {
            that.$router.go(-1)
          }, 500)
        }).catch(function(error) {
          console.log(error)
        })
      }).catch(() => {
        // on cancel
      })
    },

    toCancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
.edit-container{
  padding-top: 10px;
  .input-item{
    width: 335px;
    height: 48px;
    margin: 0 auto;
    padding: 0 15px;
    background-color: #ffffff;
    margin-bottom: 1px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    span{
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 400;
    }
    input{
      width: 260px;
      color: #747474;
      font-size: 12px;
      font-weight: 400;
      text-align: right;
    }
  }
  .footer{
    width: 100%;
    height: 58px;
    position: fixed;
    bottom: 0;
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: space-around;
    .footer-button{
      width: 150px;
      height: 40px;
      border-radius: 100px;
      background-color: #003485;
      color: #ffffff;
      font-size: 14px;
      font-weight: 600;
      border: none;
    }
    .delete{
      background-color: #ff6d63;
    }
    .cancel{
      background-color: #ffffff;
      color: #747474;
      border: 1px solid #dddddd;
    }
  }
  .input-item:nth-child(3){
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/address/edit.vue